import React, { Component } from 'react';

import TouchButton from '../TouchButton';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';

const ExerciseHeader = React.createClass({

    render () {

        let calculator;
        const title = this.props.title || null,
            allowsCalculator = this.props.calculator || false,
            difficulty = this.props.difficulty || null,
            calculatorTooltip = (<Tooltip id="calculator">Calculator allowed</Tooltip>);

        if(allowsCalculator) {
            calculator = (
                <div className="exercise-info--calculator">
                    <OverlayTrigger placement="right" overlay={calculatorTooltip}>
                        <div className="calculator"></div>
                    </OverlayTrigger>
                </div>
            );
        } else {
            calculator = null;
        }

        return (
            <div className="exercise-header">
                <h1 className="exercise-header--head">Övning {title}</h1>
                <div className="exercise-info-wrap">
                    <div className="exercise-info">
                        <p className="exercise-info--difficulty">Difficulty: {difficulty}</p>
                        {calculator}
                    </div>
                    <div className="exercise-pagination">
                        <TouchButton bsStyle="link"><Glyphicon glyph="arrow-left"/></TouchButton>
                        <span className="exercise-pagination--current">{title}</span>
                        <TouchButton bsStyle="link"><Glyphicon glyph="arrow-right"/></TouchButton>
                    </div>
                </div>
            </div>
        );
    }
});

export default ExerciseHeader;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseHeader/ExerciseHeader.js
 **/